import { check } from '@fingermarkglobal/validation';
import { NewEvent } from '@fingermarkglobal/event-store';
import { defaultRequest, publishEvent } from './default';
import { encodeProductDetails } from './util';

const registerProductCheckout = (
  { eventStoreEnabled },
  {
    sessionId,
    productVariant,
    categoryName,
    product,
    price,
    quantity,
    listName,
    storeAddress,
    organisation,
    serial,
    upsell,
  },
) => {
  const invalidParams = check({
    name: 'Register product checkout',
    parameters: {
      sessionId,
      productVariant,
      categoryName,
      product,
      price,
      quantity,
      listName,
      storeAddress,
      organisation,
      serial,
      upsell,
    },
  });

  if (invalidParams) {
    logger.debug(
      `[@fingermarkglobal/google-analytics][registerProductCheckout] Invalid params [${invalidParams}]`,
    );
    return;
  }

  const additionalPayload = {
    t: 'event',
    ec: 'Ecommerce',
    ea: 'Checkout',
    el: 1,
    pa: 'checkout',
    cos: 1,
  };

  const detailsToEncode = {
    index: 1,
    sessionId,
    storeAddress,
    serial,
    listName,
    productVariant,
    organisation,
    categoryName,
    productName: product.name,
    productSku: product.id,
    upsell,
    quantity,
    price,
    additionalPayload,
  };

  const encodedPayload = encodeProductDetails(detailsToEncode);

  Object.keys(additionalPayload).forEach(name => {
    encodedPayload.push(`${name}=${encodeURIComponent(additionalPayload[name])}`);
  });

  defaultRequest(encodedPayload.join('&'));

  if (eventStoreEnabled) {
    const e = NewEvent(
      process.env.POI_APP_EVENT_STORE_SOURCE,
      process.env.POI_APP_EVENT_STORE_APP,
      'UserInteractionRecorded',
      {},
      detailsToEncode,
    );

    publishEvent(e);
  }
};

export { registerProductCheckout };
